/* eslint-disable */
// tslint:disable

import * as request from "superagent";
import {
    SuperAgentStatic,
    SuperAgentRequest,
    Response
} from "superagent";

export type RequestHeaders = {
    [header: string]: string;
}
export type RequestHeadersHandler = (headers: RequestHeaders) => RequestHeaders;

export type ConfigureAgentHandler = (agent: SuperAgentStatic) => SuperAgentStatic;

export type ConfigureRequestHandler = (agent: SuperAgentRequest) => SuperAgentRequest;

export type CallbackHandler = (err: any, res ? : request.Response) => void;

export type Account = {
    'broker' ? : string;
    'id': number;
    'name': string;
    'parentId' ? : number;
} & {
    [key: string]: any;
};

export type ApiError = {
    'code': string;
    'messages': Array < string >
    ;
} & {
    [key: string]: any;
};

export type Asset = {
    'classId': number;
    'description': string;
    'displayName': string;
    'expired': boolean;
    'id': number;
    'isCurrency': boolean;
    'markCurrencyId': number;
    'ticker': string;
} & {
    [key: string]: any;
};

export type AssetClass = {
    'description': string;
    'id': number;
} & {
    [key: string]: any;
};

export type AttachClientRequest = {
    'aliases' ? : Array < string >
    ;
    'authInfoId': string;
    'blockfillsPortfolio' ? : Portfolio;
    'clientId' ? : number;
    'clientPortfolio' ? : Portfolio;
    'name' ? : string;
    'signatureBankSenderNames' ? : Array < string >
    ;
} & {
    [key: string]: any;
};

export type Balance = {
    'balance': string;
    'currency': string;
} & {
    [key: string]: any;
};

export type Broker = {
    'id': number;
    'name': string;
} & {
    [key: string]: any;
};

export type Client = {
    'additionalBankAccountIds' ? : {} & {
        [key: string]: any;
    };
    'aliases': Array < string >;
    'brokerPortfolioId' ? : number;
    'clientPortfolioId' ? : number;
    'creditLimit' ? : string;
    'depositAddresses': Array < DepositAddress >;
    'id': number;
    'keepkeyAccountId' ? : number;
    'name': string;
    'signatureBankSenderNames' ? : Array < string >;
    'signetAccountId' ? : number;
    'unsettledAccountId' ? : number;
    'tradingEnabled' ? : boolean;
} & {
    [key: string]: any;
};

export type CountEntriesWithAssetId = {
    'assetId': number;
    'count': number;
} & {
    [key: string]: any;
};

export type CreateClientRequest = {
    'aliases' ? : Array < string >
    ;
    'brokerPortfolio' ? : Portfolio;
    'clientPortfolio' ? : Portfolio;
    'email' ? : string;
    'name' ? : string;
    'signatureBankSenderNames' ? : Array < string >
    ;
} & {
    [key: string]: any;
};

export type CreateDepositRequest = {
    'asset': number;
    'destinationLocation': string;
    'metadata' ? : string;
    'quantity' ? : number;
    'sourceLocation': string;
    'transferMethod' ? : "blockchain" | "signet" | "sen" | "fedwire";
} & {
    [key: string]: any;
};

export type CreateUserRequest = {
    'email': string;
    'role': "admin" | "client";
    'suppressNewUserEmail': boolean;
} & {
    [key: string]: any;
};

export type CreateWithdrawalRequest = {
    'asset': number;
    'destinationLocation': string;
    'metadata' ? : string;
    'quantity' ? : number;
    'sourceLocation': string;
    'transferMethod' ? : "blockchain" | "signet" | "sen" | "fedwire";
} & {
    [key: string]: any;
};

export type Credentials = {
    'password': string;
    'username': string;
} & {
    [key: string]: any;
};

export type Credit = {
    'limit': number;
    'exposure': number;
    'utilization': number;
    'level': string;
};

export type Deposit = {
    'asset' ? : number;
    'destinationLocation' ? : string;
    'metadata' ? : string;
    'quantity' ? : number;
    'sourceLocation' ? : string;
    'transferMethod' ? : "blockchain" | "signet" | "sen" | "fedwire";
} & {
    [key: string]: any;
};

export type DepositAddress = {
    'address': string;
    'assetName': string;
} & {
    [key: string]: any;
};

export type Entity = {
    'id': number;
    'name': string;
} & {
    [key: string]: any;
};

export type Execution = {
    'date': string;
    'id' ? : string;
    'instrumentId': number;
    'price': string;
    'quantity': string;
    'side': "BUY" | "SELL";
    'time': string;
} & {
    [key: string]: any;
};

export type GetClientTradingInstrumentsResponse = Array<Instrument>

export type GetDepositsResponse = {
    'items': Array < Deposit >
    ;
    'paginationMetadata': PaginationMetadata;
} & {
    [key: string]: any;
};

export type GetExecutionsResponse = {
    'items': Array < Execution >
    ;
    'paginationMetadata': PaginationMetadata;
} & {
    [key: string]: any;
};

export type GetLogoResponse = {
    'logo': string;
} & {
    [key: string]: string;
};

export type GetMarketWidgetsResponse = Array<Instrument>

export type GetPaymentsResponse = {
    'items': Array < Payment >
    ;
    'paginationMetadata': PaginationMetadata;
} & {
    [key: string]: any;
};

export type GetHistoricalBalancesResponse = {
    'items': Array < Balance >
    ;
    'paginationMetadata': PaginationMetadata;
} & {
    [key: string]: any;
};

export type GetTradesResponse = {
    'items': Array < Trade >
    ;
    'paginationMetadata': PaginationMetadata;
} & {
    [key: string]: any;
};

export type GetTransfersResponse = {
    'items': Array < Transfer >
    ;
    'paginationMetadata': PaginationMetadata;
} & {
    [key: string]: any;
};

export type GetUsersResponse = {
    'items': Array < UserProfile >
    ;
    'paginationMetadata': PaginationMetadata;
} & {
    [key: string]: any;
};

export type GetWithdrawalsResponse = {
    'items': Array < Withdrawal >
    ;
    'paginationMetadata': PaginationMetadata;
} & {
    [key: string]: any;
};

export type Instrument = {
    'assetId': number;
    'contraAssetId'?: number;
    'defaultFeed' ? : number;
    'description': string;
    'instrumentId': number;
    'lotSize': string;
    'marketCenters' ? : Array < string >;
    'positionRatio' ? : string;
    'priceRatio' ? : string;
    'quoteCurrencyId': number;
    'tickSize': string;
    'ticker'?: string;
    'qtyInQuoteAsset'?: boolean;
} & {
    [key: string]: any;
};

export type LiquidityProvider = {
    'aliases': Array < string >
    ;
    'entityId': number;
    'name': string;
    'unsettledAccountId': number;
} & {
    [key: string]: any;
};

export type MarketCenter = {
    'description': string;
    'entityID': number;
    'id': number;
} & {
    [key: string]: any;
};

export type MarketWidgetIdentifier = {
    'baseAssetTicker': string
    'quantityAssetTicker': string
    'instrumentID': number,
    'instrumentTicker': string
    'quoteCurrencyTicker': string;
} & {
    [key: string]: any;
};

export type PaginationMetadata = {
    'hasNextPage': boolean;
    'limit': number;
    'offset': number;
} & {
    [key: string]: any;
};

export type Payment = {
    'accountId': number;
    'assetId': number;
    'associatedAssetId' ? : number;
    'clientId' ? : number;
    'clientName' ? : string;
    'counterpartyId' ? : number;
    'date': string;
    'id': string;
    'metadata' ? : string;
    'portfolioId': number;
    'price' ? : string;
    'quantity': string;
    'time': string;
    'type': string;
} & {
    [key: string]: any;
};

export type Portfolio = {
    'description': string;
    'id' ? : number;
    'name': string;
    'parentId' ? : number;
} & {
    [key: string]: any;
};

export type ReportGroup = {
    'name' ? : string;
    'rows' ? : Array < ReportRow >
    ;
} & {
    [key: string]: any;
};

export type ReportGroups = Array < ReportGroup >
;

export type ReportRow = {
    'name' ? : string;
    'value' ? : string;
} & {
    [key: string]: any;
};

export type RequestPasswordResetRequest = {
    'email': string;
    'chosenEmail'?: string;
} & {
    [key: string]: any;
};

export type ResetPasswordRequest = {
    'code': string;
    'password': string;
} & {
    [key: string]: any;
};

export type Trade = {
    'assetId' ? : number;
    'clientId' ? : number;
    'clientName' ? : string;
    'contraAssetId' ? : number;
    'date': string;
    'id' ? : string;
    'instrument': string;
    'portfolioId' ? : number;
    'price': string;
    'quantity': string;
    'side': "BUY" | "SELL";
    'time': string;
} & {
    [key: string]: any;
};

export type Transfer = {
    'accountId' ? : number;
    'assetId': number;
    'date': string;
    'id': string;
    'metadata' ? : string;
    'portfolioClientId' ? : number;
    'portfolioClientName' ? : string;
    'portfolioId' ? : number;
    'price': string;
    'quantity': string;
    'time': string;
    'type' ? : string;
} & {
    [key: string]: any;
};

export type UserProfile = {
    'id': string;
    'jwtToken': string;
    'relatedEntityId' ? : number;
    'role': "admin" | "client";
    'username': string;
    'featureFlags' ? : Array< string >;
} & {
    [key: string]: any;
};

export type Withdrawal = {
    'asset' ? : number;
    'destinationLocation' ? : string;
    'metadata' ? : string;
    'quantity' ? : number;
    'sourceLocation' ? : string;
    'transferMethod' ? : "blockchain" | "signet" | "sen" | "fedwire";
} & {
    [key: string]: any;
};

export type Response_getAccounts_200 = Array < Account >
;

export type Response_getAssets_200 = Array < Asset >
;

export type Response_getAssetsClasses_200 = Array < AssetClass >
;

export type Response_getAssetsClassesByIdAssets_200 = Array < Asset >
;

export type Response_getBrokers_200 = Array < Broker >
;

export type Response_getClients_200 = Array < Client >
;

export type Response_getCredit_200 = Array < Credit >
;

export type Response_getClientsByIdDepositAddresses_200 = Array < DepositAddress >
;

export type Response_getEntities_200 = Array < Entity >
;

export type Response_getInstruments_200 = Array < Instrument >
;

export type Response_getLiquidityProviders_200 = Array < LiquidityProvider >
;

export type Response_getMarketCenters_200 = Array < MarketCenter >
;

export type Response_getPortfolios_200 = Array < Portfolio >
;

export type Response_getPortfoliosByIdBalances_200 = {
    client_portfolio?:          Array < Balance >,
    client_cash_portfolio?:     Array < Balance >,
    client_margin_portfolio?:   Array < Balance >
};

export type Response_getPortfoliosByIdPositionEquity_200 = {
    client_portfolio?:          Balance,
    client_cash_portfolio?:     Balance,
    client_margin_portfolio?:   Balance
}

export type Response_getPortfoliosByIdPaymentsCount_200 = Array < CountEntriesWithAssetId >
;

export type Response_getPortfoliosByIdTransfersCount_200 = Array < CountEntriesWithAssetId >
;

export type Response_getReportsVolumePdf_200 = {};

export type Logger = {
    log: (line: string) => any
};

export interface ResponseWithBody < S extends number, T > extends Response {
    status: S;
    body: T;
}

export type QueryParameters = {
    [param: string]: any
};

export interface CommonRequestOptions {
    $queryParameters ? : QueryParameters;
    $domain ? : string;
    $path ? : string | ((path: string) => string);
    $retries ? : number; // number of retries; see: https://github.com/visionmedia/superagent/blob/master/docs/index.md#retrying-requests
    $timeout ? : number; // request timeout in milliseconds; see: https://github.com/visionmedia/superagent/blob/master/docs/index.md#timeouts
    $deadline ? : number; // request deadline in milliseconds; see: https://github.com/visionmedia/superagent/blob/master/docs/index.md#timeouts
}

/**
 * Blockfills Web Backend API Specification
 * @class Api
 * @param {(string)} [domainOrOptions] - The project domain.
 */
export class Api {

    private domain: string = "http://trade.blockfills.com/api/v1";
    private errorHandlers: CallbackHandler[] = [];
    private requestHeadersHandler ? : RequestHeadersHandler;
    private configureAgentHandler ? : ConfigureAgentHandler;
    private configureRequestHandler ? : ConfigureRequestHandler;

    constructor(domain ? : string, private logger ? : Logger) {
        if (domain) {
            this.domain = domain;
        }
    }

    getDomain() {
        return this.domain;
    }

    addErrorHandler(handler: CallbackHandler) {
        this.errorHandlers.push(handler);
    }

    setRequestHeadersHandler(handler: RequestHeadersHandler) {
        this.requestHeadersHandler = handler;
    }

    setConfigureAgentHandler(handler: ConfigureAgentHandler) {
        this.configureAgentHandler = handler;
    }

    setConfigureRequestHandler(handler: ConfigureRequestHandler) {
        this.configureRequestHandler = handler;
    }

    private request(method: string, url: string, body: any, headers: RequestHeaders, queryParameters: QueryParameters, form: any, reject: CallbackHandler, resolve: CallbackHandler, opts: CommonRequestOptions) {
        if (this.logger) {
            this.logger.log(`Call ${method} ${url}`);
        }

        const agent = this.configureAgentHandler ?
            this.configureAgentHandler(request.default) :
            request.default;

        let req = agent(method, url);
        if (this.configureRequestHandler) {
            req = this.configureRequestHandler(req);
        }

        req = req.query(queryParameters);

        if (body) {
            req.send(body);

            if (typeof(body) === 'object' && !(body.constructor.name === 'Buffer')) {
                headers['Content-Type'] = 'application/json';
            }
        }

        if (Object.keys(form).length > 0) {
            req.type('form');
            req.send(form);
        }

        if (this.requestHeadersHandler) {
            headers = this.requestHeadersHandler({
                ...headers
            });
        }

        req.set(headers);

        if (opts.$retries && opts.$retries > 0) {
            req.retry(opts.$retries);
        }

        if (opts.$timeout && opts.$timeout > 0 || opts.$deadline && opts.$deadline > 0) {
            req.timeout({
                deadline: opts.$deadline,
                response: opts.$timeout
            });
        }

        req.end((error, response) => {
            // an error will also be emitted for a 4xx and 5xx status code
            // the error object will then have error.status and error.response fields
            // see superagent error handling: https://github.com/visionmedia/superagent/blob/master/docs/index.md#error-handling
            if (error) {
                reject(error);
                this.errorHandlers.forEach(handler => handler(error));
            } else {
                resolve(response);
            }
        });
    }

    private convertParameterCollectionFormat < T > (param: T, collectionFormat: string | undefined): T | string {
        if (Array.isArray(param) && param.length >= 2) {
            switch (collectionFormat) {
                case "csv":
                    return param.join(",");
                case "ssv":
                    return param.join(" ");
                case "tsv":
                    return param.join("\t");
                case "pipes":
                    return param.join("|");
                default:
                    return param;
            }
        }

        return param;
    }

    getAccountsURL(parameters: {} & CommonRequestOptions): string {
        let queryParameters: QueryParameters = {};
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/accounts';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        if (parameters.$queryParameters) {
            queryParameters = {
                ...queryParameters,
                ...parameters.$queryParameters
            };
        }

        let keys = Object.keys(queryParameters);
        return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '');
    }

    /**
     * Returns a list of accounts.
     * @method
     * @name Api#getAccounts
     */
    getAccounts(parameters: {} & CommonRequestOptions): Promise < ResponseWithBody < 200, Response_getAccounts_200 > | ResponseWithBody < 403, void > | ResponseWithBody < 404, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/accounts';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    getAssetsURL(parameters: {} & CommonRequestOptions): string {
        let queryParameters: QueryParameters = {};
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/assets';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        if (parameters.$queryParameters) {
            queryParameters = {
                ...queryParameters,
                ...parameters.$queryParameters
            };
        }

        let keys = Object.keys(queryParameters);
        return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '');
    }

    /**
     * Returns a list of assets.
     * @method
     * @name Api#getAssets
     */
    getAssets(parameters: {} & CommonRequestOptions): Promise < ResponseWithBody < 200, Response_getAssets_200 > | ResponseWithBody < 400, ApiError > | ResponseWithBody < 403, void > | ResponseWithBody < 404, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/assets';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    /**
     * Returns a list of tradable assets.
     * @method
     * @name Api#getTradableAssets
     */
    getTradableAssets(parameters: {} & CommonRequestOptions): Promise < ResponseWithBody < 200, Response_getAssets_200 > | ResponseWithBody < 400, ApiError > | ResponseWithBody < 403, void > | ResponseWithBody < 404, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/trading-assets';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    getAssetsClassesURL(parameters: {} & CommonRequestOptions): string {
        let queryParameters: QueryParameters = {};
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/assets-classes';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        if (parameters.$queryParameters) {
            queryParameters = {
                ...queryParameters,
                ...parameters.$queryParameters
            };
        }

        let keys = Object.keys(queryParameters);
        return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '');
    }

    /**
     * Returns a list of assets classes.
     * @method
     * @name Api#getAssetsClasses
     */
    getAssetsClasses(parameters: {} & CommonRequestOptions): Promise < ResponseWithBody < 200, Response_getAssetsClasses_200 > | ResponseWithBody < 400, ApiError > | ResponseWithBody < 403, void > | ResponseWithBody < 404, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/assets-classes';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    getAssetsClassesByIdAssetsURL(parameters: {
        'id': number,
    } & CommonRequestOptions): string {
        let queryParameters: QueryParameters = {};
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/assets-classes/{id}/assets';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        path = path.replace(
            '{id}',
            `${encodeURIComponent(this.convertParameterCollectionFormat(
                        parameters['id'],
                        ''
                    ).toString())}`
        );

        if (parameters.$queryParameters) {
            queryParameters = {
                ...queryParameters,
                ...parameters.$queryParameters
            };
        }

        let keys = Object.keys(queryParameters);
        return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '');
    }

    /**
     * Returns a list of assetss.
     * @method
     * @name Api#getAssetsClassesByIdAssets
     * @param {integer} id - Asset class ID.
     */
    getAssetsClassesByIdAssets(parameters: {
        'id': number,
    } & CommonRequestOptions): Promise < ResponseWithBody < 200, Response_getAssetsClassesByIdAssets_200 > | ResponseWithBody < 400, ApiError > | ResponseWithBody < 403, void > | ResponseWithBody < 404, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/assets-classes/{id}/assets';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            path = path.replace(
                '{id}',
                `${encodeURIComponent(this.convertParameterCollectionFormat(
                    parameters['id'],
                    ''
                ).toString())}`
            );

            if (parameters['id'] === undefined) {
                reject(new Error('Missing required  parameter: id'));
                return;
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    getAssetsByIdPaymentsURL(parameters: {
        'id': number,
        'portfolioId' ? : number,
        'accountId' ? : number,
        'counterpartyId' ? : number,
        'offset' ? : number,
        'limit' ? : number,
        'fromDateTime' ? : string,
        'toDateTime' ? : string,
        'orderBy' ? : string,
        'direction' ? : "asc" | "desc",
    } & CommonRequestOptions): string {
        let queryParameters: QueryParameters = {};
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/assets/{id}/payments';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        path = path.replace(
            '{id}',
            `${encodeURIComponent(this.convertParameterCollectionFormat(
                        parameters['id'],
                        ''
                    ).toString())}`
        );
        if (parameters['portfolioId'] !== undefined) {
            queryParameters['portfolioId'] = this.convertParameterCollectionFormat(
                parameters['portfolioId'],
                ''
            );
        }

        if (parameters['accountId'] !== undefined) {
            queryParameters['accountId'] = this.convertParameterCollectionFormat(
                parameters['accountId'],
                ''
            );
        }

        if (parameters['counterpartyId'] !== undefined) {
            queryParameters['counterpartyId'] = this.convertParameterCollectionFormat(
                parameters['counterpartyId'],
                ''
            );
        }

        if (parameters['offset'] !== undefined) {
            queryParameters['offset'] = this.convertParameterCollectionFormat(
                parameters['offset'],
                ''
            );
        }

        if (parameters['limit'] !== undefined) {
            queryParameters['limit'] = this.convertParameterCollectionFormat(
                parameters['limit'],
                ''
            );
        }

        if (parameters['fromDateTime'] !== undefined) {
            queryParameters['fromDateTime'] = this.convertParameterCollectionFormat(
                parameters['fromDateTime'],
                ''
            );
        }

        if (parameters['toDateTime'] !== undefined) {
            queryParameters['toDateTime'] = this.convertParameterCollectionFormat(
                parameters['toDateTime'],
                ''
            );
        }

        if (parameters['orderBy'] !== undefined) {
            queryParameters['orderBy'] = this.convertParameterCollectionFormat(
                parameters['orderBy'],
                ''
            );
        }

        if (parameters['direction'] !== undefined) {
            queryParameters['direction'] = this.convertParameterCollectionFormat(
                parameters['direction'],
                ''
            );
        }

        if (parameters.$queryParameters) {
            queryParameters = {
                ...queryParameters,
                ...parameters.$queryParameters
            };
        }

        let keys = Object.keys(queryParameters);
        return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '');
    }

    /**
     * Returns payments.
     * @method
     * @name Api#getAssetsByIdPayments
     * @param {integer} id - Asset ID.
     * @param {integer} portfolioId - Portfolio ID.
     * @param {integer} accountId - Account ID.
     * @param {integer} counterpartyId - Counterparty ID.
     * @param {integer} offset - The number of items to skip before starting to collect the result set.
     * @param {integer} limit - The number of items to return.
     * @param {string} fromDateTime - Filter items by date-time.
     * @param {string} toDateTime - Filter items by date-time.
     * @param {string} orderBy - Column to sort.
     * @param {string} direction - Sorting direction.
     */
    getAssetsByIdPayments(parameters: {
        'id': number,
        'portfolioId' ? : number,
        'accountId' ? : number,
        'counterpartyId' ? : number,
        'offset' ? : number,
        'limit' ? : number,
        'fromDateTime' ? : string,
        'toDateTime' ? : string,
        'orderBy' ? : string,
        'direction' ? : "asc" | "desc",
    } & CommonRequestOptions): Promise < ResponseWithBody < 200, GetPaymentsResponse > | ResponseWithBody < 400, ApiError > | ResponseWithBody < 403, void > | ResponseWithBody < 404, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/assets/{id}/payments';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            path = path.replace(
                '{id}',
                `${encodeURIComponent(this.convertParameterCollectionFormat(
                    parameters['id'],
                    ''
                ).toString())}`
            );

            if (parameters['id'] === undefined) {
                reject(new Error('Missing required  parameter: id'));
                return;
            }

            if (parameters['portfolioId'] !== undefined) {
                queryParameters['portfolioId'] = this.convertParameterCollectionFormat(
                    parameters['portfolioId'],
                    ''
                );
            }

            if (parameters['accountId'] !== undefined) {
                queryParameters['accountId'] = this.convertParameterCollectionFormat(
                    parameters['accountId'],
                    ''
                );
            }

            if (parameters['counterpartyId'] !== undefined) {
                queryParameters['counterpartyId'] = this.convertParameterCollectionFormat(
                    parameters['counterpartyId'],
                    ''
                );
            }

            if (parameters['offset'] !== undefined) {
                queryParameters['offset'] = this.convertParameterCollectionFormat(
                    parameters['offset'],
                    ''
                );
            }

            if (parameters['limit'] !== undefined) {
                queryParameters['limit'] = this.convertParameterCollectionFormat(
                    parameters['limit'],
                    ''
                );
            }

            if (parameters['fromDateTime'] !== undefined) {
                queryParameters['fromDateTime'] = this.convertParameterCollectionFormat(
                    parameters['fromDateTime'],
                    ''
                );
            }

            if (parameters['toDateTime'] !== undefined) {
                queryParameters['toDateTime'] = this.convertParameterCollectionFormat(
                    parameters['toDateTime'],
                    ''
                );
            }

            if (parameters['orderBy'] !== undefined) {
                queryParameters['orderBy'] = this.convertParameterCollectionFormat(
                    parameters['orderBy'],
                    ''
                );
            }

            if (parameters['direction'] !== undefined) {
                queryParameters['direction'] = this.convertParameterCollectionFormat(
                    parameters['direction'],
                    ''
                );
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    getAssetsByIdTransfersURL(parameters: {
        'id': number,
        'type': string,
        'portfolioId' ? : number,
        'accountId' ? : number,
        'offset' ? : number,
        'limit' ? : number,
        'fromDateTime' ? : string,
        'toDateTime' ? : string,
        'orderBy' ? : string,
        'direction' ? : "asc" | "desc",
    } & CommonRequestOptions): string {
        let queryParameters: QueryParameters = {};
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/assets/{id}/transfers';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        path = path.replace(
            '{id}',
            `${encodeURIComponent(this.convertParameterCollectionFormat(
                        parameters['id'],
                        ''
                    ).toString())}`
        );
        if (parameters['type'] !== undefined) {
            queryParameters['type'] = this.convertParameterCollectionFormat(
                parameters['type'],
                ''
            );
        }

        if (parameters['portfolioId'] !== undefined) {
            queryParameters['portfolioId'] = this.convertParameterCollectionFormat(
                parameters['portfolioId'],
                ''
            );
        }

        if (parameters['accountId'] !== undefined) {
            queryParameters['accountId'] = this.convertParameterCollectionFormat(
                parameters['accountId'],
                ''
            );
        }

        if (parameters['offset'] !== undefined) {
            queryParameters['offset'] = this.convertParameterCollectionFormat(
                parameters['offset'],
                ''
            );
        }

        if (parameters['limit'] !== undefined) {
            queryParameters['limit'] = this.convertParameterCollectionFormat(
                parameters['limit'],
                ''
            );
        }

        if (parameters['fromDateTime'] !== undefined) {
            queryParameters['fromDateTime'] = this.convertParameterCollectionFormat(
                parameters['fromDateTime'],
                ''
            );
        }

        if (parameters['toDateTime'] !== undefined) {
            queryParameters['toDateTime'] = this.convertParameterCollectionFormat(
                parameters['toDateTime'],
                ''
            );
        }

        if (parameters['orderBy'] !== undefined) {
            queryParameters['orderBy'] = this.convertParameterCollectionFormat(
                parameters['orderBy'],
                ''
            );
        }

        if (parameters['direction'] !== undefined) {
            queryParameters['direction'] = this.convertParameterCollectionFormat(
                parameters['direction'],
                ''
            );
        }

        if (parameters.$queryParameters) {
            queryParameters = {
                ...queryParameters,
                ...parameters.$queryParameters
            };
        }

        let keys = Object.keys(queryParameters);
        return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '');
    }

    /**
     * Returns transfers.
     * @method
     * @name Api#getAssetsByIdTransfers
     * @param {integer} id - Asset ID.
     * @param {string} type - valid values: deposit, withdrawal, ledgerEntry
     * @param {integer} portfolioId - Portfolio ID.
     * @param {integer} accountId - Account ID.
     * @param {integer} offset - The number of items to skip before starting to collect the result set.
     * @param {integer} limit - The number of items to return.
     * @param {string} fromDateTime - Filter items by date-time.
     * @param {string} toDateTime - Filter items by date-time.
     * @param {string} orderBy - Column to sort.
     * @param {string} direction - Sorting direction.
     */
    getAssetsByIdTransfers(parameters: {
        'id': number,
        'type': string,
        'portfolioId' ? : number,
        'accountId' ? : number,
        'offset' ? : number,
        'limit' ? : number,
        'fromDateTime' ? : string,
        'toDateTime' ? : string,
        'orderBy' ? : string,
        'direction' ? : "asc" | "desc",
    } & CommonRequestOptions): Promise < ResponseWithBody < 200, GetTransfersResponse > | ResponseWithBody < 400, ApiError > | ResponseWithBody < 403, void > | ResponseWithBody < 404, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/assets/{id}/transfers';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            path = path.replace(
                '{id}',
                `${encodeURIComponent(this.convertParameterCollectionFormat(
                    parameters['id'],
                    ''
                ).toString())}`
            );

            if (parameters['id'] === undefined) {
                reject(new Error('Missing required  parameter: id'));
                return;
            }

            if (parameters['type'] !== undefined) {
                queryParameters['type'] = this.convertParameterCollectionFormat(
                    parameters['type'],
                    ''
                );
            }

            if (parameters['type'] === undefined) {
                reject(new Error('Missing required  parameter: type'));
                return;
            }

            if (parameters['portfolioId'] !== undefined) {
                queryParameters['portfolioId'] = this.convertParameterCollectionFormat(
                    parameters['portfolioId'],
                    ''
                );
            }

            if (parameters['accountId'] !== undefined) {
                queryParameters['accountId'] = this.convertParameterCollectionFormat(
                    parameters['accountId'],
                    ''
                );
            }

            if (parameters['offset'] !== undefined) {
                queryParameters['offset'] = this.convertParameterCollectionFormat(
                    parameters['offset'],
                    ''
                );
            }

            if (parameters['limit'] !== undefined) {
                queryParameters['limit'] = this.convertParameterCollectionFormat(
                    parameters['limit'],
                    ''
                );
            }

            if (parameters['fromDateTime'] !== undefined) {
                queryParameters['fromDateTime'] = this.convertParameterCollectionFormat(
                    parameters['fromDateTime'],
                    ''
                );
            }

            if (parameters['toDateTime'] !== undefined) {
                queryParameters['toDateTime'] = this.convertParameterCollectionFormat(
                    parameters['toDateTime'],
                    ''
                );
            }

            if (parameters['orderBy'] !== undefined) {
                queryParameters['orderBy'] = this.convertParameterCollectionFormat(
                    parameters['orderBy'],
                    ''
                );
            }

            if (parameters['direction'] !== undefined) {
                queryParameters['direction'] = this.convertParameterCollectionFormat(
                    parameters['direction'],
                    ''
                );
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    postAuthLoginURL(parameters: {
        'credentials' ? : Credentials,
    } & CommonRequestOptions): string {
        let queryParameters: QueryParameters = {};
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/auth/login';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        if (parameters.$queryParameters) {
            queryParameters = {
                ...queryParameters,
                ...parameters.$queryParameters
            };
        }

        queryParameters = {};

        let keys = Object.keys(queryParameters);
        return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '');
    }

    /**
     * Authenticate user and returns JWT token.
     * @method
     * @name Api#postAuthLogin
     * @param {} credentials - Blockfills Web Backend API Specification
     */
    postAuthLogin(parameters: {
        'credentials' ? : Credentials,
    } & CommonRequestOptions): Promise < ResponseWithBody < 200, UserProfile > | ResponseWithBody < 400, ApiError > | ResponseWithBody < 401, void > | ResponseWithBody < 404, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/auth/login';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            if (parameters['credentials'] !== undefined) {
                body = parameters['credentials'];
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            form = queryParameters;
            queryParameters = {};

            this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    getBrokersURL(parameters: {} & CommonRequestOptions): string {
        let queryParameters: QueryParameters = {};
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/brokers';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        if (parameters.$queryParameters) {
            queryParameters = {
                ...queryParameters,
                ...parameters.$queryParameters
            };
        }

        let keys = Object.keys(queryParameters);
        return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '');
    }

    /**
     * Returns a list of brokers.
     * @method
     * @name Api#getBrokers
     */
    getBrokers(parameters: {} & CommonRequestOptions): Promise < ResponseWithBody < 200, Response_getBrokers_200 > | ResponseWithBody < 403, void > | ResponseWithBody < 404, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/brokers';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    getClientsURL(parameters: {
        'query' ? : string,
        'offset' ? : number,
        'limit' ? : number,
    } & CommonRequestOptions): string {
        let queryParameters: QueryParameters = {};
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/clients';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        if (parameters['query'] !== undefined) {
            queryParameters['query'] = this.convertParameterCollectionFormat(
                parameters['query'],
                ''
            );
        }

        if (parameters['offset'] !== undefined) {
            queryParameters['offset'] = this.convertParameterCollectionFormat(
                parameters['offset'],
                ''
            );
        }

        if (parameters['limit'] !== undefined) {
            queryParameters['limit'] = this.convertParameterCollectionFormat(
                parameters['limit'],
                ''
            );
        }

        if (parameters.$queryParameters) {
            queryParameters = {
                ...queryParameters,
                ...parameters.$queryParameters
            };
        }

        let keys = Object.keys(queryParameters);
        return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '');
    }

    /**
     * Returns client profiles.
     * @method
     * @name Api#getClients
     * @param {string} query - Query parameter to search client by name.
     * @param {integer} offset - The number of items to skip before starting to collect the result set.
     * @param {integer} limit - The number of items to return.
     */
    getClients(parameters: {
        'query' ? : string,
        'offset' ? : number,
        'limit' ? : number,
    } & CommonRequestOptions): Promise < ResponseWithBody < 200, Response_getClients_200 > | ResponseWithBody < 400, ApiError > | ResponseWithBody < 403, void > | ResponseWithBody < 404, void > | ResponseWithBody < 422, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/clients';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            if (parameters['query'] !== undefined) {
                queryParameters['query'] = this.convertParameterCollectionFormat(
                    parameters['query'],
                    ''
                );
            }

            if (parameters['offset'] !== undefined) {
                queryParameters['offset'] = this.convertParameterCollectionFormat(
                    parameters['offset'],
                    ''
                );
            }

            if (parameters['limit'] !== undefined) {
                queryParameters['limit'] = this.convertParameterCollectionFormat(
                    parameters['limit'],
                    ''
                );
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    postClientsURL(parameters: {
        'createClient' ? : CreateClientRequest,
    } & CommonRequestOptions): string {
        let queryParameters: QueryParameters = {};
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/clients';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        if (parameters.$queryParameters) {
            queryParameters = {
                ...queryParameters,
                ...parameters.$queryParameters
            };
        }

        queryParameters = {};

        let keys = Object.keys(queryParameters);
        return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '');
    }

    /**
     * Create client.
     * @method
     * @name Api#postClients
     * @param {} createClient - Blockfills Web Backend API Specification
     */
    postClients(parameters: {
        'createClient' ? : CreateClientRequest,
    } & CommonRequestOptions): Promise < ResponseWithBody < 200, void > | ResponseWithBody < 400, ApiError > | ResponseWithBody < 403, void > | ResponseWithBody < 404, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/clients';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            if (parameters['createClient'] !== undefined) {
                body = parameters['createClient'];
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            form = queryParameters;
            queryParameters = {};

            this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    patchClientsURL(parameters: {
        'updateClient' ? : Client,
    } & CommonRequestOptions): string {
        let queryParameters: QueryParameters = {};
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/clients';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        if (parameters.$queryParameters) {
            queryParameters = {
                ...queryParameters,
                ...parameters.$queryParameters
            };
        }

        let keys = Object.keys(queryParameters);
        return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '');
    }

    /**
     * Update client.
     * @method
     * @name Api#patchClients
     * @param {} updateClient - Blockfills Web Backend API Specification
     */
    patchClients(parameters: {
        'updateClient' ? : Client,
    } & CommonRequestOptions): Promise < ResponseWithBody < 200, void > | ResponseWithBody < 400, ApiError > | ResponseWithBody < 403, void > | ResponseWithBody < 404, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/clients';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            if (parameters['updateClient'] !== undefined) {
                body = parameters['updateClient'];
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('PATCH', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    getClientsByIdURL(parameters: {
        'id': number,
    } & CommonRequestOptions): string {
        let queryParameters: QueryParameters = {};
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/clients/{id}';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        path = path.replace(
            '{id}',
            `${encodeURIComponent(this.convertParameterCollectionFormat(
                        parameters['id'],
                        ''
                    ).toString())}`
        );

        if (parameters.$queryParameters) {
            queryParameters = {
                ...queryParameters,
                ...parameters.$queryParameters
            };
        }

        let keys = Object.keys(queryParameters);
        return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '');
    }

    /**
     * Returns client's profile.
     * @method
     * @name Api#getClientsById
     * @param {integer} id - Client ID.
     */
    getClientsById(parameters: {
        'id': number,
    } & CommonRequestOptions): Promise < ResponseWithBody < 200, Client > | ResponseWithBody < 400, ApiError > | ResponseWithBody < 403, void > | ResponseWithBody < 404, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/clients/{id}';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            path = path.replace(
                '{id}',
                `${encodeURIComponent(this.convertParameterCollectionFormat(
                    parameters['id'],
                    ''
                ).toString())}`
            );

            if (parameters['id'] === undefined) {
                reject(new Error('Missing required  parameter: id'));
                return;
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    getClientsByIdDepositAddressesURL(parameters: {
        'id': number,
    } & CommonRequestOptions): string {
        let queryParameters: QueryParameters = {};
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/clients/{id}/deposit-addresses';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        path = path.replace(
            '{id}',
            `${encodeURIComponent(this.convertParameterCollectionFormat(
                        parameters['id'],
                        ''
                    ).toString())}`
        );

        if (parameters.$queryParameters) {
            queryParameters = {
                ...queryParameters,
                ...parameters.$queryParameters
            };
        }

        let keys = Object.keys(queryParameters);
        return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '');
    }

    /**
     * Returns a list of deposit addresses.
     * @method
     * @name Api#getClientsByIdDepositAddresses
     * @param {integer} id - Client id.
     */
    getClientsByIdDepositAddresses(parameters: {
        'id': number,
    } & CommonRequestOptions): Promise < ResponseWithBody < 200, Response_getClientsByIdDepositAddresses_200 > | ResponseWithBody < 400, ApiError > | ResponseWithBody < 403, void > | ResponseWithBody < 404, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/clients/{id}/deposit-addresses';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            path = path.replace(
                '{id}',
                `${encodeURIComponent(this.convertParameterCollectionFormat(
                    parameters['id'],
                    ''
                ).toString())}`
            );

            if (parameters['id'] === undefined) {
                reject(new Error('Missing required  parameter: id'));
                return;
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

        /**
     * Returns client's credit.
     * @method
     * @name Api#getCredit
     * @param {integer} client_portfolio_id - Client portfolio ID.
     * @param {integer} client_cash_portfolio_id - Client cash portfolio ID.
     */
    getCredit(parameters: {
        'client_id' ? : number,
    } & CommonRequestOptions): Promise < ResponseWithBody < 200, Response_getCredit_200 > | ResponseWithBody < 400, ApiError > | ResponseWithBody < 403, void > | ResponseWithBody < 404, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/credit';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            if (parameters['client_id'] !== undefined) {
                queryParameters['client_id'] = this.convertParameterCollectionFormat(
                    parameters['client_id'],
                    ''
                );
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        })
        }
    

    getDepositsURL(parameters: {
        'offset' ? : number,
        'limit' ? : number,
    } & CommonRequestOptions): string {
        let queryParameters: QueryParameters = {};
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/deposits';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        if (parameters['offset'] !== undefined) {
            queryParameters['offset'] = this.convertParameterCollectionFormat(
                parameters['offset'],
                ''
            );
        }

        if (parameters['limit'] !== undefined) {
            queryParameters['limit'] = this.convertParameterCollectionFormat(
                parameters['limit'],
                ''
            );
        }

        if (parameters.$queryParameters) {
            queryParameters = {
                ...queryParameters,
                ...parameters.$queryParameters
            };
        }

        let keys = Object.keys(queryParameters);
        return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '');
    }

    /**
     * Returns client deposits.
     * @method
     * @name Api#getDeposits
     * @param {integer} offset - The number of items to skip before starting to collect the result set.
     * @param {integer} limit - The number of items to return.
     */
    getDeposits(parameters: {
        'offset' ? : number,
        'limit' ? : number,
    } & CommonRequestOptions): Promise < ResponseWithBody < 200, GetDepositsResponse > | ResponseWithBody < 400, ApiError > | ResponseWithBody < 403, void > | ResponseWithBody < 404, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/deposits';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            if (parameters['offset'] !== undefined) {
                queryParameters['offset'] = this.convertParameterCollectionFormat(
                    parameters['offset'],
                    ''
                );
            }

            if (parameters['limit'] !== undefined) {
                queryParameters['limit'] = this.convertParameterCollectionFormat(
                    parameters['limit'],
                    ''
                );
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    postDepositsURL(parameters: {
        'deposit' ? : CreateDepositRequest,
    } & CommonRequestOptions): string {
        let queryParameters: QueryParameters = {};
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/deposits';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        if (parameters.$queryParameters) {
            queryParameters = {
                ...queryParameters,
                ...parameters.$queryParameters
            };
        }

        queryParameters = {};

        let keys = Object.keys(queryParameters);
        return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '');
    }

    /**
     * Create deposit.
     * @method
     * @name Api#postDeposits
     * @param {} deposit - Blockfills Web Backend API Specification
     */
    postDeposits(parameters: {
        'deposit' ? : CreateDepositRequest,
    } & CommonRequestOptions): Promise < ResponseWithBody < 200, void > | ResponseWithBody < 400, ApiError > | ResponseWithBody < 403, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/deposits';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            if (parameters['deposit'] !== undefined) {
                body = parameters['deposit'];
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            form = queryParameters;
            queryParameters = {};

            this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    getEntitiesURL(parameters: {} & CommonRequestOptions): string {
        let queryParameters: QueryParameters = {};
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/entities';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        if (parameters.$queryParameters) {
            queryParameters = {
                ...queryParameters,
                ...parameters.$queryParameters
            };
        }

        let keys = Object.keys(queryParameters);
        return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '');
    }

    /**
     * Returns a list of entitys.
     * @method
     * @name Api#getEntities
     */
    getEntities(parameters: {} & CommonRequestOptions): Promise < ResponseWithBody < 200, Response_getEntities_200 > | ResponseWithBody < 403, void > | ResponseWithBody < 404, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/entities';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    getExecutionsURL(parameters: {
        'portfolioId' ? : number,
        'side' ? : "BUY" | "SELL",
        'instrumentId' ? : number,
        'offset' ? : number,
        'limit' ? : number,
        'fromDateTime' ? : string,
        'toDateTime' ? : string,
    } & CommonRequestOptions): string {
        let queryParameters: QueryParameters = {};
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/executions';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        if (parameters['portfolioId'] !== undefined) {
            queryParameters['portfolioId'] = this.convertParameterCollectionFormat(
                parameters['portfolioId'],
                ''
            );
        }

        if (parameters['side'] !== undefined) {
            queryParameters['side'] = this.convertParameterCollectionFormat(
                parameters['side'],
                ''
            );
        }

        if (parameters['instrumentId'] !== undefined) {
            queryParameters['instrumentId'] = this.convertParameterCollectionFormat(
                parameters['instrumentId'],
                ''
            );
        }

        if (parameters['offset'] !== undefined) {
            queryParameters['offset'] = this.convertParameterCollectionFormat(
                parameters['offset'],
                ''
            );
        }

        if (parameters['limit'] !== undefined) {
            queryParameters['limit'] = this.convertParameterCollectionFormat(
                parameters['limit'],
                ''
            );
        }

        if (parameters['fromDateTime'] !== undefined) {
            queryParameters['fromDateTime'] = this.convertParameterCollectionFormat(
                parameters['fromDateTime'],
                ''
            );
        }

        if (parameters['toDateTime'] !== undefined) {
            queryParameters['toDateTime'] = this.convertParameterCollectionFormat(
                parameters['toDateTime'],
                ''
            );
        }

        if (parameters.$queryParameters) {
            queryParameters = {
                ...queryParameters,
                ...parameters.$queryParameters
            };
        }

        let keys = Object.keys(queryParameters);
        return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '');
    }

    /**
     * Returns executions.
     * @method
     * @name Api#getExecutions
     * @param {integer} portfolioId - Portfolio ID.
     * @param {string} side - Side.
     * @param {integer} instrumentId - Instrument ID.
     * @param {integer} offset - The number of items to skip before starting to collect the result set.
     * @param {integer} limit - The number of items to return.
     * @param {string} fromDateTime - Filter items by date-time.
     * @param {string} toDateTime - Filter items by date-time.
     */
    getExecutions(parameters: {
        'portfolioId' ? : number,
        'side' ? : "BUY" | "SELL",
        'instrumentId' ? : number,
        'offset' ? : number,
        'limit' ? : number,
        'fromDateTime' ? : string,
        'toDateTime' ? : string,
    } & CommonRequestOptions): Promise < ResponseWithBody < 200, GetExecutionsResponse > | ResponseWithBody < 400, ApiError > | ResponseWithBody < 403, void > | ResponseWithBody < 404, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/executions';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            if (parameters['portfolioId'] !== undefined) {
                queryParameters['portfolioId'] = this.convertParameterCollectionFormat(
                    parameters['portfolioId'],
                    ''
                );
            }

            if (parameters['side'] !== undefined) {
                queryParameters['side'] = this.convertParameterCollectionFormat(
                    parameters['side'],
                    ''
                );
            }

            if (parameters['instrumentId'] !== undefined) {
                queryParameters['instrumentId'] = this.convertParameterCollectionFormat(
                    parameters['instrumentId'],
                    ''
                );
            }

            if (parameters['offset'] !== undefined) {
                queryParameters['offset'] = this.convertParameterCollectionFormat(
                    parameters['offset'],
                    ''
                );
            }

            if (parameters['limit'] !== undefined) {
                queryParameters['limit'] = this.convertParameterCollectionFormat(
                    parameters['limit'],
                    ''
                );
            }

            if (parameters['fromDateTime'] !== undefined) {
                queryParameters['fromDateTime'] = this.convertParameterCollectionFormat(
                    parameters['fromDateTime'],
                    ''
                );
            }

            if (parameters['toDateTime'] !== undefined) {
                queryParameters['toDateTime'] = this.convertParameterCollectionFormat(
                    parameters['toDateTime'],
                    ''
                );
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    getInstrumentsURL(parameters: {} & CommonRequestOptions): string {
        let queryParameters: QueryParameters = {};
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/instruments';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        if (parameters.$queryParameters) {
            queryParameters = {
                ...queryParameters,
                ...parameters.$queryParameters
            };
        }

        let keys = Object.keys(queryParameters);
        return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '');
    }

    /**
     * Returns a list of instruments.
     * @method
     * @name Api#getInstruments
     */
    getInstruments(parameters: {} & CommonRequestOptions): Promise < ResponseWithBody < 200, Response_getInstruments_200 > | ResponseWithBody < 403, void > | ResponseWithBody < 404, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/instruments';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    getLiquidityProvidersURL(parameters: {} & CommonRequestOptions): string {
        let queryParameters: QueryParameters = {};
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/liquidity-providers';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        if (parameters.$queryParameters) {
            queryParameters = {
                ...queryParameters,
                ...parameters.$queryParameters
            };
        }

        let keys = Object.keys(queryParameters);
        return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '');
    }

    /**
     * Returns a list of entitys.
     * @method
     * @name Api#getLiquidityProviders
     */
    getLiquidityProviders(parameters: {} & CommonRequestOptions): Promise < ResponseWithBody < 200, Response_getLiquidityProviders_200 > | ResponseWithBody < 403, void > | ResponseWithBody < 404, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/liquidity-providers';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    getMarketCentersURL(parameters: {} & CommonRequestOptions): string {
        let queryParameters: QueryParameters = {};
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/market-centers';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        if (parameters.$queryParameters) {
            queryParameters = {
                ...queryParameters,
                ...parameters.$queryParameters
            };
        }

        let keys = Object.keys(queryParameters);
        return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '');
    }

    /**
     * Returns a list of marketCenters.
     * @method
     * @name Api#getMarketCenters
     */
    getMarketCenters(parameters: {} & CommonRequestOptions): Promise < ResponseWithBody < 200, Response_getMarketCenters_200 > | ResponseWithBody < 403, void > | ResponseWithBody < 404, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/market-centers';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    getMeURL(parameters: {} & CommonRequestOptions): string {
        let queryParameters: QueryParameters = {};
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/me';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        if (parameters.$queryParameters) {
            queryParameters = {
                ...queryParameters,
                ...parameters.$queryParameters
            };
        }

        let keys = Object.keys(queryParameters);
        return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '');
    }

    /**
     * Returns user's profile.
     * @method
     * @name Api#getMe
     */
    getMe(parameters: {} & CommonRequestOptions): Promise < ResponseWithBody < 200, UserProfile > | ResponseWithBody < 400, ApiError > | ResponseWithBody < 403, void > | ResponseWithBody < 404, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/me';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    getPortfoliosURL(parameters: {
        'query' ? : string,
    } & CommonRequestOptions): string {
        let queryParameters: QueryParameters = {};
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/portfolios';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        if (parameters['query'] !== undefined) {
            queryParameters['query'] = this.convertParameterCollectionFormat(
                parameters['query'],
                ''
            );
        }

        if (parameters.$queryParameters) {
            queryParameters = {
                ...queryParameters,
                ...parameters.$queryParameters
            };
        }

        let keys = Object.keys(queryParameters);
        return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '');
    }

    /**
     * Returns a list of portfolios.
     * @method
     * @name Api#getPortfolios
     * @param {string} query - Query parameter to search portfolio by name.
     */
    getPortfolios(parameters: {
        'query' ? : string,
    } & CommonRequestOptions): Promise < ResponseWithBody < 200, Response_getPortfolios_200 > | ResponseWithBody < 403, void > | ResponseWithBody < 404, void > | ResponseWithBody < 422, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/portfolios';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            if (parameters['query'] !== undefined) {
                queryParameters['query'] = this.convertParameterCollectionFormat(
                    parameters['query'],
                    ''
                );
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    getPortfoliosByIdBalancesURL(parameters: {
        'id': number,
    } & CommonRequestOptions): string {
        let queryParameters: QueryParameters = {};
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/portfolios/{id}/balances';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        path = path.replace(
            '{id}',
            `${encodeURIComponent(this.convertParameterCollectionFormat(
                        parameters['id'],
                        ''
                    ).toString())}`
        );

        if (parameters.$queryParameters) {
            queryParameters = {
                ...queryParameters,
                ...parameters.$queryParameters
            };
        }

        let keys = Object.keys(queryParameters);
        return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '');
    }
      
     /**
     * Returns historical balances.
     * @method
     * @name Api#getHistoricalBalancesbyDate
     * @param {integer} portfolioId - Portfolio ID.
     * @param {integer} id - Asset ID
     * @param {integer} offset - The number of items to skip before starting to collect the result set.
     * @param {integer} limit - The number of items to return.
     * @param {string} fromDateTime - Filter items by date-time.
     * @param {string} orderBy - Column to sort.
     * @param {string} direction - Sorting direction.
     */
    getHistoricalBalancesbyDate(parameters: {
        'id' ? : number,
        'portfolioId' ? : number,
        'offset' ? : number,
        'limit' ? : number,
        'fromDateTime' ? : string,
        'orderBy' ? : string,
        'direction' ? : "asc" | "desc",
    } & CommonRequestOptions): Promise < ResponseWithBody < 200, GetHistoricalBalancesResponse > | ResponseWithBody < 400, ApiError > | ResponseWithBody < 403, void > | ResponseWithBody < 404, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/positionHistory';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';
        
            if (parameters['portfolioId'] !== undefined) {
                queryParameters['portfolioID'] = this.convertParameterCollectionFormat(
                    parameters['portfolioId'],
                    ''
                );
            }
    

            if (parameters['offset'] !== undefined) {
                queryParameters['offset'] = this.convertParameterCollectionFormat(
                    parameters['offset'],
                    ''
                );
            }

            if (parameters['limit'] !== undefined) {
                queryParameters['limit'] = this.convertParameterCollectionFormat(
                    parameters['limit'],
                    ''
                );
            }

            if (parameters['fromDateTime'] !== undefined) {
                queryParameters['fromDateTime'] = this.convertParameterCollectionFormat(
                    (parameters['fromDateTime']).split('T')[0],
                    ''
                );
            }

            if (parameters['id'] !== undefined) {
                if (typeof(parameters['id']) == 'string'){
                    parameters['id'] = parseInt(parameters['id'])
                }
                queryParameters['id'] = this.convertParameterCollectionFormat(
                    parameters['id'],
                    ''
                );
            }

            if (parameters['orderBy'] !== undefined) {
                queryParameters['orderBy'] = this.convertParameterCollectionFormat(
                    parameters['orderBy'],
                    ''
                );
            }

            if (parameters['direction'] !== undefined) {
                queryParameters['direction'] = this.convertParameterCollectionFormat(
                    parameters['direction'],
                    ''
                );
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    /**
     * Returns a list of balances.
     * @method
     * @name Api#getPortfoliosByIdBalances
     * @param {integer} id - portfolio ID.
     */
    getPortfoliosByIdBalances(parameters: {
        'id': number,
    } & CommonRequestOptions): Promise < ResponseWithBody < 200, Response_getPortfoliosByIdBalances_200 > | ResponseWithBody < 400, ApiError > | ResponseWithBody < 403, void > | ResponseWithBody < 404, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/portfolios/{id}/balances';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            path = path.replace(
                '{id}',
                `${encodeURIComponent(this.convertParameterCollectionFormat(
                    parameters['id'],
                    ''
                ).toString())}`
            );

            if (parameters['id'] === undefined) {
                reject(new Error('Missing required  parameter: id'));
                return;
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    getPortfoliosByIdPaymentsCountURL(parameters: {
        'id': number,
    } & CommonRequestOptions): string {
        let queryParameters: QueryParameters = {};
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/portfolios/{id}/payments/count';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        path = path.replace(
            '{id}',
            `${encodeURIComponent(this.convertParameterCollectionFormat(
                        parameters['id'],
                        ''
                    ).toString())}`
        );

        if (parameters.$queryParameters) {
            queryParameters = {
                ...queryParameters,
                ...parameters.$queryParameters
            };
        }

        let keys = Object.keys(queryParameters);
        return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '');
    }

    /**
     * Count payments.
     * @method
     * @name Api#getPortfoliosByIdPaymentsCount
     * @param {integer} id - Portfolio ID.
     */
    getPortfoliosByIdPaymentsCount(parameters: {
        'id': number,
    } & CommonRequestOptions): Promise < ResponseWithBody < 200, Response_getPortfoliosByIdPaymentsCount_200 > | ResponseWithBody < 403, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/portfolios/{id}/payments/count';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            path = path.replace(
                '{id}',
                `${encodeURIComponent(this.convertParameterCollectionFormat(
                    parameters['id'],
                    ''
                ).toString())}`
            );

            if (parameters['id'] === undefined) {
                reject(new Error('Missing required  parameter: id'));
                return;
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    getPortfoliosByIdPositionEquityURL(parameters: {
        'id': number,
    } & CommonRequestOptions): string {
        let queryParameters: QueryParameters = {};
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/portfolios/{id}/position-equity';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        path = path.replace(
            '{id}',
            `${encodeURIComponent(this.convertParameterCollectionFormat(
                        parameters['id'],
                        ''
                    ).toString())}`
        );

        if (parameters.$queryParameters) {
            queryParameters = {
                ...queryParameters,
                ...parameters.$queryParameters
            };
        }

        let keys = Object.keys(queryParameters);
        return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '');
    }

    /**
     * This is just the sum of the USD value of all positions in the portfolio.
     * @method
     * @name Api#getPortfoliosByIdPositionEquity
     * @param {integer} id - portfolio ID.
     */
    getPortfoliosByIdPositionEquity(parameters: {
        'id': number,
    } & CommonRequestOptions): Promise < ResponseWithBody < 200, Response_getPortfoliosByIdPositionEquity_200 > | ResponseWithBody < 400, ApiError > | ResponseWithBody < 403, void > | ResponseWithBody < 404, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/portfolios/{id}/position-equity';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            path = path.replace(
                '{id}',
                `${encodeURIComponent(this.convertParameterCollectionFormat(
                    parameters['id'],
                    ''
                ).toString())}`
            );

            if (parameters['id'] === undefined) {
                reject(new Error('Missing required  parameter: id'));
                return;
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    getPortfoliosByIdTransfersCountURL(parameters: {
        'id': number,
    } & CommonRequestOptions): string {
        let queryParameters: QueryParameters = {};
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/portfolios/{id}/transfers/count';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        path = path.replace(
            '{id}',
            `${encodeURIComponent(this.convertParameterCollectionFormat(
                        parameters['id'],
                        ''
                    ).toString())}`
        );

        if (parameters.$queryParameters) {
            queryParameters = {
                ...queryParameters,
                ...parameters.$queryParameters
            };
        }

        let keys = Object.keys(queryParameters);
        return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '');
    }

    /**
     * Count transfers.
     * @method
     * @name Api#getPortfoliosByIdTransfersCount
     * @param {integer} id - Portfolio ID.
     */
    getPortfoliosByIdTransfersCount(parameters: {
        'id': number,
    } & CommonRequestOptions): Promise < ResponseWithBody < 200, Response_getPortfoliosByIdTransfersCount_200 > | ResponseWithBody < 403, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/portfolios/{id}/transfers/count';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            path = path.replace(
                '{id}',
                `${encodeURIComponent(this.convertParameterCollectionFormat(
                    parameters['id'],
                    ''
                ).toString())}`
            );

            if (parameters['id'] === undefined) {
                reject(new Error('Missing required  parameter: id'));
                return;
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    getReportsFeeURL(parameters: {
        'portfolioId' ? : number,
        'groupByDay' ? : boolean,
        'groupByInstrument' ? : boolean,
        'groupByFeeType' ? : boolean,
        'fromDateTime' ? : string,
        'toDateTime' ? : string,
    } & CommonRequestOptions): string {
        let queryParameters: QueryParameters = {};
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/reports/fee';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        if (parameters['portfolioId'] !== undefined) {
            queryParameters['portfolioId'] = this.convertParameterCollectionFormat(
                parameters['portfolioId'],
                ''
            );
        }

        if (parameters['groupByDay'] !== undefined) {
            queryParameters['groupByDay'] = this.convertParameterCollectionFormat(
                parameters['groupByDay'],
                ''
            );
        }

        if (parameters['groupByInstrument'] !== undefined) {
            queryParameters['groupByInstrument'] = this.convertParameterCollectionFormat(
                parameters['groupByInstrument'],
                ''
            );
        }

        if (parameters['groupByFeeType'] !== undefined) {
            queryParameters['groupByFeeType'] = this.convertParameterCollectionFormat(
                parameters['groupByFeeType'],
                ''
            );
        }

        if (parameters['fromDateTime'] !== undefined) {
            queryParameters['fromDateTime'] = this.convertParameterCollectionFormat(
                parameters['fromDateTime'],
                ''
            );
        }

        if (parameters['toDateTime'] !== undefined) {
            queryParameters['toDateTime'] = this.convertParameterCollectionFormat(
                parameters['toDateTime'],
                ''
            );
        }

        if (parameters.$queryParameters) {
            queryParameters = {
                ...queryParameters,
                ...parameters.$queryParameters
            };
        }

        let keys = Object.keys(queryParameters);
        return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '');
    }

    /**
     * Generates fee report.
     * @method
     * @name Api#getReportsFee
     * @param {number} portfolioId - Portfolio ID.
     * @param {boolean} groupByDay - Group by day.
     * @param {boolean} groupByInstrument - Group by instrument.
     * @param {boolean} groupByFeeType - Group by asset class.
     * @param {string} fromDateTime - Filter items by date-time.
     * @param {string} toDateTime - Filter items by date-time.
     */
    getReportsFee(parameters: {
        'portfolioId' ? : number,
        'groupByDay' ? : boolean,
        'groupByInstrument' ? : boolean,
        'groupByFeeType' ? : boolean,
        'fromDateTime' ? : string,
        'toDateTime' ? : string,
    } & CommonRequestOptions): Promise < ResponseWithBody < 200, ReportGroups > | ResponseWithBody < 403, void > | ResponseWithBody < 422, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/reports/fee';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            if (parameters['portfolioId'] !== undefined) {
                queryParameters['portfolioId'] = this.convertParameterCollectionFormat(
                    parameters['portfolioId'],
                    ''
                );
            }

            if (parameters['groupByDay'] !== undefined) {
                queryParameters['groupByDay'] = this.convertParameterCollectionFormat(
                    parameters['groupByDay'],
                    ''
                );
            }

            if (parameters['groupByInstrument'] !== undefined) {
                queryParameters['groupByInstrument'] = this.convertParameterCollectionFormat(
                    parameters['groupByInstrument'],
                    ''
                );
            }

            if (parameters['groupByFeeType'] !== undefined) {
                queryParameters['groupByFeeType'] = this.convertParameterCollectionFormat(
                    parameters['groupByFeeType'],
                    ''
                );
            }

            if (parameters['fromDateTime'] !== undefined) {
                queryParameters['fromDateTime'] = this.convertParameterCollectionFormat(
                    parameters['fromDateTime'],
                    ''
                );
            }

            if (parameters['toDateTime'] !== undefined) {
                queryParameters['toDateTime'] = this.convertParameterCollectionFormat(
                    parameters['toDateTime'],
                    ''
                );
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    getReportsMarkupURL(parameters: {
        'portfolioId' ? : number,
        'fromDateTime' ? : string,
        'toDateTime' ? : string,
    } & CommonRequestOptions): string {
        let queryParameters: QueryParameters = {};
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/reports/markup';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        if (parameters['portfolioId'] !== undefined) {
            queryParameters['portfolioId'] = this.convertParameterCollectionFormat(
                parameters['portfolioId'],
                ''
            );
        }

        if (parameters['fromDateTime'] !== undefined) {
            queryParameters['fromDateTime'] = this.convertParameterCollectionFormat(
                parameters['fromDateTime'],
                ''
            );
        }

        if (parameters['toDateTime'] !== undefined) {
            queryParameters['toDateTime'] = this.convertParameterCollectionFormat(
                parameters['toDateTime'],
                ''
            );
        }

        if (parameters.$queryParameters) {
            queryParameters = {
                ...queryParameters,
                ...parameters.$queryParameters
            };
        }

        let keys = Object.keys(queryParameters);
        return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '');
    }

    /**
     * Generates Markup PNL report.
     * @method
     * @name Api#getReportsMarkup
     * @param {number} portfolioId - Portfolio ID.
     * @param {string} fromDateTime - Filter items by date-time.
     * @param {string} toDateTime - Filter items by date-time.
     */
    getReportsMarkup(parameters: {
        'portfolioId' ? : number,
        'fromDateTime' ? : string,
        'toDateTime' ? : string,
    } & CommonRequestOptions): Promise < ResponseWithBody < 200, ReportGroups > | ResponseWithBody < 403, void > | ResponseWithBody < 422, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/reports/markup';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            if (parameters['portfolioId'] !== undefined) {
                queryParameters['portfolioId'] = this.convertParameterCollectionFormat(
                    parameters['portfolioId'],
                    ''
                );
            }

            if (parameters['fromDateTime'] !== undefined) {
                queryParameters['fromDateTime'] = this.convertParameterCollectionFormat(
                    parameters['fromDateTime'],
                    ''
                );
            }

            if (parameters['toDateTime'] !== undefined) {
                queryParameters['toDateTime'] = this.convertParameterCollectionFormat(
                    parameters['toDateTime'],
                    ''
                );
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    getReportsVolumeURL(parameters: {
        'portfolioId' ? : number,
        'groupByDay' ? : boolean,
        'groupByInstrument' ? : boolean,
        'groupByAsset' ? : boolean,
        'groupByTermAsset' ? : boolean,
        'groupByAssetClass' ? : boolean,
        'fromDateTime' ? : string,
        'toDateTime' ? : string,
    } & CommonRequestOptions): string {
        let queryParameters: QueryParameters = {};
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/reports/volume';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        if (parameters['portfolioId'] !== undefined) {
            queryParameters['portfolioId'] = this.convertParameterCollectionFormat(
                parameters['portfolioId'],
                ''
            );
        }

        if (parameters['groupByDay'] !== undefined) {
            queryParameters['groupByDay'] = this.convertParameterCollectionFormat(
                parameters['groupByDay'],
                ''
            );
        }

        if (parameters['groupByInstrument'] !== undefined) {
            queryParameters['groupByInstrument'] = this.convertParameterCollectionFormat(
                parameters['groupByInstrument'],
                ''
            );
        }

        if (parameters['groupByAsset'] !== undefined) {
            queryParameters['groupByAsset'] = this.convertParameterCollectionFormat(
                parameters['groupByAsset'],
                ''
            );
        }

        if (parameters['groupByTermAsset'] !== undefined) {
            queryParameters['groupByTermAsset'] = this.convertParameterCollectionFormat(
                parameters['groupByTermAsset'],
                ''
            );
        }

        if (parameters['groupByAssetClass'] !== undefined) {
            queryParameters['groupByAssetClass'] = this.convertParameterCollectionFormat(
                parameters['groupByAssetClass'],
                ''
            );
        }

        if (parameters['fromDateTime'] !== undefined) {
            queryParameters['fromDateTime'] = this.convertParameterCollectionFormat(
                parameters['fromDateTime'],
                ''
            );
        }

        if (parameters['toDateTime'] !== undefined) {
            queryParameters['toDateTime'] = this.convertParameterCollectionFormat(
                parameters['toDateTime'],
                ''
            );
        }

        if (parameters.$queryParameters) {
            queryParameters = {
                ...queryParameters,
                ...parameters.$queryParameters
            };
        }

        let keys = Object.keys(queryParameters);
        return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '');
    }

    /**
     * Generates volume report.
     * @method
     * @name Api#getReportsVolume
     * @param {number} portfolioId - Portfolio ID.
     * @param {boolean} groupByDay - Group by day.
     * @param {boolean} groupByInstrument - Group by instrument.
     * @param {boolean} groupByAsset - Group by asset.
     * @param {boolean} groupByTermAsset - Group by term asset.
     * @param {boolean} groupByAssetClass - Group by asset class.
     * @param {string} fromDateTime - Filter items by date-time.
     * @param {string} toDateTime - Filter items by date-time.
     */
    getReportsVolume(parameters: {
        'portfolioId' ? : number,
        'groupByDay' ? : boolean,
        'groupByInstrument' ? : boolean,
        'groupByAsset' ? : boolean,
        'groupByTermAsset' ? : boolean,
        'groupByAssetClass' ? : boolean,
        'fromDateTime' ? : string,
        'toDateTime' ? : string,
    } & CommonRequestOptions): Promise < ResponseWithBody < 200, ReportGroups > | ResponseWithBody < 403, void > | ResponseWithBody < 404, void > | ResponseWithBody < 422, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/reports/volume';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            if (parameters['portfolioId'] !== undefined) {
                queryParameters['portfolioId'] = this.convertParameterCollectionFormat(
                    parameters['portfolioId'],
                    ''
                );
            }

            if (parameters['groupByDay'] !== undefined) {
                queryParameters['groupByDay'] = this.convertParameterCollectionFormat(
                    parameters['groupByDay'],
                    ''
                );
            }

            if (parameters['groupByInstrument'] !== undefined) {
                queryParameters['groupByInstrument'] = this.convertParameterCollectionFormat(
                    parameters['groupByInstrument'],
                    ''
                );
            }

            if (parameters['groupByAsset'] !== undefined) {
                queryParameters['groupByAsset'] = this.convertParameterCollectionFormat(
                    parameters['groupByAsset'],
                    ''
                );
            }

            if (parameters['groupByTermAsset'] !== undefined) {
                queryParameters['groupByTermAsset'] = this.convertParameterCollectionFormat(
                    parameters['groupByTermAsset'],
                    ''
                );
            }

            if (parameters['groupByAssetClass'] !== undefined) {
                queryParameters['groupByAssetClass'] = this.convertParameterCollectionFormat(
                    parameters['groupByAssetClass'],
                    ''
                );
            }

            if (parameters['fromDateTime'] !== undefined) {
                queryParameters['fromDateTime'] = this.convertParameterCollectionFormat(
                    parameters['fromDateTime'],
                    ''
                );
            }

            if (parameters['toDateTime'] !== undefined) {
                queryParameters['toDateTime'] = this.convertParameterCollectionFormat(
                    parameters['toDateTime'],
                    ''
                );
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    getReportsVolumePdfURL(parameters: {
        'portfolioId' ? : number,
        'groupByDay' ? : boolean,
        'groupByInstrument' ? : boolean,
        'groupByAsset' ? : boolean,
        'groupByTermAsset' ? : boolean,
        'groupByAssetClass' ? : boolean,
        'fromDateTime' ? : string,
        'toDateTime' ? : string,
    } & CommonRequestOptions): string {
        let queryParameters: QueryParameters = {};
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/reports/volume.pdf';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        if (parameters['portfolioId'] !== undefined) {
            queryParameters['portfolioId'] = this.convertParameterCollectionFormat(
                parameters['portfolioId'],
                ''
            );
        }

        if (parameters['groupByDay'] !== undefined) {
            queryParameters['groupByDay'] = this.convertParameterCollectionFormat(
                parameters['groupByDay'],
                ''
            );
        }

        if (parameters['groupByInstrument'] !== undefined) {
            queryParameters['groupByInstrument'] = this.convertParameterCollectionFormat(
                parameters['groupByInstrument'],
                ''
            );
        }

        if (parameters['groupByAsset'] !== undefined) {
            queryParameters['groupByAsset'] = this.convertParameterCollectionFormat(
                parameters['groupByAsset'],
                ''
            );
        }

        if (parameters['groupByTermAsset'] !== undefined) {
            queryParameters['groupByTermAsset'] = this.convertParameterCollectionFormat(
                parameters['groupByTermAsset'],
                ''
            );
        }

        if (parameters['groupByAssetClass'] !== undefined) {
            queryParameters['groupByAssetClass'] = this.convertParameterCollectionFormat(
                parameters['groupByAssetClass'],
                ''
            );
        }

        if (parameters['fromDateTime'] !== undefined) {
            queryParameters['fromDateTime'] = this.convertParameterCollectionFormat(
                parameters['fromDateTime'],
                ''
            );
        }

        if (parameters['toDateTime'] !== undefined) {
            queryParameters['toDateTime'] = this.convertParameterCollectionFormat(
                parameters['toDateTime'],
                ''
            );
        }

        if (parameters.$queryParameters) {
            queryParameters = {
                ...queryParameters,
                ...parameters.$queryParameters
            };
        }

        let keys = Object.keys(queryParameters);
        return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '');
    }

    /**
     * Generates volume report.
     * @method
     * @name Api#getReportsVolumePdf
     * @param {number} portfolioId - Portfolio ID.
     * @param {boolean} groupByDay - Group by day.
     * @param {boolean} groupByInstrument - Group by instrument.
     * @param {boolean} groupByAsset - Group by asset.
     * @param {boolean} groupByTermAsset - Group by term asset.
     * @param {boolean} groupByAssetClass - Group by asset class.
     * @param {string} fromDateTime - Filter items by date-time.
     * @param {string} toDateTime - Filter items by date-time.
     */
    getReportsVolumePdf(parameters: {
        'portfolioId' ? : number,
        'groupByDay' ? : boolean,
        'groupByInstrument' ? : boolean,
        'groupByAsset' ? : boolean,
        'groupByTermAsset' ? : boolean,
        'groupByAssetClass' ? : boolean,
        'fromDateTime' ? : string,
        'toDateTime' ? : string,
    } & CommonRequestOptions): Promise < ResponseWithBody < 200, Response_getReportsVolumePdf_200 > | ResponseWithBody < 403, void > | ResponseWithBody < 422, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/reports/volume.pdf';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            if (parameters['portfolioId'] !== undefined) {
                queryParameters['portfolioId'] = this.convertParameterCollectionFormat(
                    parameters['portfolioId'],
                    ''
                );
            }

            if (parameters['groupByDay'] !== undefined) {
                queryParameters['groupByDay'] = this.convertParameterCollectionFormat(
                    parameters['groupByDay'],
                    ''
                );
            }

            if (parameters['groupByInstrument'] !== undefined) {
                queryParameters['groupByInstrument'] = this.convertParameterCollectionFormat(
                    parameters['groupByInstrument'],
                    ''
                );
            }

            if (parameters['groupByAsset'] !== undefined) {
                queryParameters['groupByAsset'] = this.convertParameterCollectionFormat(
                    parameters['groupByAsset'],
                    ''
                );
            }

            if (parameters['groupByTermAsset'] !== undefined) {
                queryParameters['groupByTermAsset'] = this.convertParameterCollectionFormat(
                    parameters['groupByTermAsset'],
                    ''
                );
            }

            if (parameters['groupByAssetClass'] !== undefined) {
                queryParameters['groupByAssetClass'] = this.convertParameterCollectionFormat(
                    parameters['groupByAssetClass'],
                    ''
                );
            }

            if (parameters['fromDateTime'] !== undefined) {
                queryParameters['fromDateTime'] = this.convertParameterCollectionFormat(
                    parameters['fromDateTime'],
                    ''
                );
            }

            if (parameters['toDateTime'] !== undefined) {
                queryParameters['toDateTime'] = this.convertParameterCollectionFormat(
                    parameters['toDateTime'],
                    ''
                );
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    postSecurityRequestPasswordResetURL(parameters: {
        'requestPasswordReset' ? : RequestPasswordResetRequest,
    } & CommonRequestOptions): string {
        let queryParameters: QueryParameters = {};
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/security/request-password-reset';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        if (parameters.$queryParameters) {
            queryParameters = {
                ...queryParameters,
                ...parameters.$queryParameters
            };
        }

        queryParameters = {};

        let keys = Object.keys(queryParameters);
        return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '');
    }

    /**
     * Request password reset link.
     * @method
     * @name Api#postSecurityRequestPasswordReset
     * @param {} requestPasswordReset - Blockfills Web Backend API Specification
     */
    postSecurityRequestPasswordReset(parameters: {
        'requestPasswordReset' ? : RequestPasswordResetRequest,
    } & CommonRequestOptions): Promise < ResponseWithBody < 200, void > | ResponseWithBody < 400, ApiError > | ResponseWithBody < 403, void > | ResponseWithBody < 404, void > | ResponseWithBody < 422, ApiError > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/security/request-password-reset';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            if (parameters['requestPasswordReset'] !== undefined) {
                body = parameters['requestPasswordReset'];
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            form = queryParameters;
            queryParameters = {};

            this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    postSecurityResetPasswordURL(parameters: {
        'resetPasswordRequest' ? : ResetPasswordRequest,
    } & CommonRequestOptions): string {
        let queryParameters: QueryParameters = {};
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/security/reset-password';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        if (parameters.$queryParameters) {
            queryParameters = {
                ...queryParameters,
                ...parameters.$queryParameters
            };
        }

        queryParameters = {};

        let keys = Object.keys(queryParameters);
        return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '');
    }

    /**
     * Reset password.
     * @method
     * @name Api#postSecurityResetPassword
     * @param {} resetPasswordRequest - Blockfills Web Backend API Specification
     */
    postSecurityResetPassword(parameters: {
        'resetPasswordRequest' ? : ResetPasswordRequest,
    } & CommonRequestOptions): Promise < ResponseWithBody < 200, void > | ResponseWithBody < 400, ApiError > | ResponseWithBody < 403, void > | ResponseWithBody < 404, void > | ResponseWithBody < 422, ApiError > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/security/reset-password';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            if (parameters['resetPasswordRequest'] !== undefined) {
                body = parameters['resetPasswordRequest'];
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            form = queryParameters;
            queryParameters = {};

            this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    getTradesURL(parameters: {
        'portfolioId' ? : number,
        'offset' ? : number,
        'limit' ? : number,
        'fromDateTime' ? : string,
        'toDateTime' ? : string,
        'orderBy' ? : string,
        'direction' ? : "asc" | "desc",
    } & CommonRequestOptions): string {
        let queryParameters: QueryParameters = {};
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/trades';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        if (parameters['portfolioId'] !== undefined) {
            queryParameters['portfolioId'] = this.convertParameterCollectionFormat(
                parameters['portfolioId'],
                ''
            );
        }

        if (parameters['offset'] !== undefined) {
            queryParameters['offset'] = this.convertParameterCollectionFormat(
                parameters['offset'],
                ''
            );
        }

        if (parameters['limit'] !== undefined) {
            queryParameters['limit'] = this.convertParameterCollectionFormat(
                parameters['limit'],
                ''
            );
        }

        if (parameters['fromDateTime'] !== undefined) {
            queryParameters['fromDateTime'] = this.convertParameterCollectionFormat(
                parameters['fromDateTime'],
                ''
            );
        }

        if (parameters['toDateTime'] !== undefined) {
            queryParameters['toDateTime'] = this.convertParameterCollectionFormat(
                parameters['toDateTime'],
                ''
            );
        }

        if (parameters['orderBy'] !== undefined) {
            queryParameters['orderBy'] = this.convertParameterCollectionFormat(
                parameters['orderBy'],
                ''
            );
        }

        if (parameters['direction'] !== undefined) {
            queryParameters['direction'] = this.convertParameterCollectionFormat(
                parameters['direction'],
                ''
            );
        }

        if (parameters.$queryParameters) {
            queryParameters = {
                ...queryParameters,
                ...parameters.$queryParameters
            };
        }

        let keys = Object.keys(queryParameters);
        return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '');
    }

    /**
     * Returns trades.
     * @method
     * @name Api#getTrades
     * @param {integer} portfolioId - Portfolio ID.
     * @param {integer} offset - The number of items to skip before starting to collect the result set.
     * @param {integer} limit - The number of items to return.
     * @param {string} fromDateTime - Filter items by date-time.
     * @param {string} toDateTime - Filter items by date-time.
     * @param {string} orderBy - Column to sort.
     * @param {string} direction - Sorting direction.
     */
    getTrades(parameters: {
        'portfolioId' ? : number,
        'offset' ? : number,
        'limit' ? : number,
        'fromDateTime' ? : string,
        'toDateTime' ? : string,
        'orderBy' ? : string,
        'direction' ? : "asc" | "desc",
    } & CommonRequestOptions): Promise < ResponseWithBody < 200, GetTradesResponse > | ResponseWithBody < 400, ApiError > | ResponseWithBody < 403, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/trades';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            if (parameters['portfolioId'] !== undefined) {
                queryParameters['portfolioId'] = this.convertParameterCollectionFormat(
                    parameters['portfolioId'],
                    ''
                );
            }

            if (parameters['offset'] !== undefined) {
                queryParameters['offset'] = this.convertParameterCollectionFormat(
                    parameters['offset'],
                    ''
                );
            }

            if (parameters['limit'] !== undefined) {
                queryParameters['limit'] = this.convertParameterCollectionFormat(
                    parameters['limit'],
                    ''
                );
            }

            if (parameters['fromDateTime'] !== undefined) {
                queryParameters['fromDateTime'] = this.convertParameterCollectionFormat(
                    parameters['fromDateTime'],
                    ''
                );
            }

            if (parameters['toDateTime'] !== undefined) {
                queryParameters['toDateTime'] = this.convertParameterCollectionFormat(
                    parameters['toDateTime'],
                    ''
                );
            }

            if (parameters['orderBy'] !== undefined) {
                queryParameters['orderBy'] = this.convertParameterCollectionFormat(
                    parameters['orderBy'],
                    ''
                );
            }

            if (parameters['direction'] !== undefined) {
                queryParameters['direction'] = this.convertParameterCollectionFormat(
                    parameters['direction'],
                    ''
                );
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    getUsersURL(parameters: {
        'offset' ? : number,
        'limit' ? : number,
    } & CommonRequestOptions): string {
        let queryParameters: QueryParameters = {};
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/users';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        if (parameters['offset'] !== undefined) {
            queryParameters['offset'] = this.convertParameterCollectionFormat(
                parameters['offset'],
                ''
            );
        }

        if (parameters['limit'] !== undefined) {
            queryParameters['limit'] = this.convertParameterCollectionFormat(
                parameters['limit'],
                ''
            );
        }

        if (parameters.$queryParameters) {
            queryParameters = {
                ...queryParameters,
                ...parameters.$queryParameters
            };
        }

        let keys = Object.keys(queryParameters);
        return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '');
    }

    /**
     * Returns users.
     * @method
     * @name Api#getUsers
     * @param {integer} offset - The number of items to skip before starting to collect the result set.
     * @param {integer} limit - The number of items to return.
     */
    getUsers(parameters: {
        'offset' ? : number,
        'limit' ? : number,
    } & CommonRequestOptions): Promise < ResponseWithBody < 200, GetUsersResponse > | ResponseWithBody < 400, ApiError > | ResponseWithBody < 403, void > | ResponseWithBody < 404, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/users';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            if (parameters['offset'] !== undefined) {
                queryParameters['offset'] = this.convertParameterCollectionFormat(
                    parameters['offset'],
                    ''
                );
            }

            if (parameters['limit'] !== undefined) {
                queryParameters['limit'] = this.convertParameterCollectionFormat(
                    parameters['limit'],
                    ''
                );
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    postUsersURL(parameters: {
        'createUserRequest' ? : CreateUserRequest,
    } & CommonRequestOptions): string {
        let queryParameters: QueryParameters = {};
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/users';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        if (parameters.$queryParameters) {
            queryParameters = {
                ...queryParameters,
                ...parameters.$queryParameters
            };
        }

        queryParameters = {};

        let keys = Object.keys(queryParameters);
        return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '');
    }

    /**
     * Add a new user.
     * @method
     * @name Api#postUsers
     * @param {} createUserRequest - Blockfills Web Backend API Specification
     */
    postUsers(parameters: {
        'createUserRequest' ? : CreateUserRequest,
    } & CommonRequestOptions): Promise < ResponseWithBody < 200, UserProfile > | ResponseWithBody < 400, ApiError > | ResponseWithBody < 403, void > | ResponseWithBody < 404, void > | ResponseWithBody < 500, ApiError >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/users';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            if (parameters['createUserRequest'] !== undefined) {
                body = parameters['createUserRequest'];
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            form = queryParameters;
            queryParameters = {};

            this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    postUsersAttachClientURL(parameters: {
        'attachClient' ? : AttachClientRequest,
    } & CommonRequestOptions): string {
        let queryParameters: QueryParameters = {};
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/users/attach-client';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        if (parameters.$queryParameters) {
            queryParameters = {
                ...queryParameters,
                ...parameters.$queryParameters
            };
        }

        queryParameters = {};

        let keys = Object.keys(queryParameters);
        return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '');
    }

    /**
     * Attaches new or existing client to the user.
     * @method
     * @name Api#postUsersAttachClient
     * @param {} attachClient - Blockfills Web Backend API Specification
     */
    postUsersAttachClient(parameters: {
        'attachClient' ? : AttachClientRequest,
    } & CommonRequestOptions): Promise < ResponseWithBody < 200, void > | ResponseWithBody < 400, ApiError > | ResponseWithBody < 403, void > | ResponseWithBody < 404, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/users/attach-client';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            if (parameters['attachClient'] !== undefined) {
                body = parameters['attachClient'];
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            form = queryParameters;
            queryParameters = {};

            this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    getWithdrawalsURL(parameters: {
        'offset' ? : number,
        'limit' ? : number,
    } & CommonRequestOptions): string {
        let queryParameters: QueryParameters = {};
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/withdrawals';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        if (parameters['offset'] !== undefined) {
            queryParameters['offset'] = this.convertParameterCollectionFormat(
                parameters['offset'],
                ''
            );
        }

        if (parameters['limit'] !== undefined) {
            queryParameters['limit'] = this.convertParameterCollectionFormat(
                parameters['limit'],
                ''
            );
        }

        if (parameters.$queryParameters) {
            queryParameters = {
                ...queryParameters,
                ...parameters.$queryParameters
            };
        }

        let keys = Object.keys(queryParameters);
        return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '');
    }

    /**
     * Returns client withdrawals.
     * @method
     * @name Api#getWithdrawals
     * @param {integer} offset - The number of items to skip before starting to collect the result set.
     * @param {integer} limit - The number of items to return.
     */
    getWithdrawals(parameters: {
        'offset' ? : number,
        'limit' ? : number,
    } & CommonRequestOptions): Promise < ResponseWithBody < 200, GetWithdrawalsResponse > | ResponseWithBody < 400, ApiError > | ResponseWithBody < 403, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/withdrawals';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            if (parameters['offset'] !== undefined) {
                queryParameters['offset'] = this.convertParameterCollectionFormat(
                    parameters['offset'],
                    ''
                );
            }

            if (parameters['limit'] !== undefined) {
                queryParameters['limit'] = this.convertParameterCollectionFormat(
                    parameters['limit'],
                    ''
                );
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    postWithdrawalsURL(parameters: {
        'withdrawal' ? : CreateWithdrawalRequest,
    } & CommonRequestOptions): string {
        let queryParameters: QueryParameters = {};
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/withdrawals';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        if (parameters.$queryParameters) {
            queryParameters = {
                ...queryParameters,
                ...parameters.$queryParameters
            };
        }

        queryParameters = {};

        let keys = Object.keys(queryParameters);
        return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '');
    }

    /**
     * Create withdrawal.
     * @method
     * @name Api#postWithdrawals
     * @param {} withdrawal - Blockfills Web Backend API Specification
     */
    postWithdrawals(parameters: {
        'withdrawal' ? : CreateWithdrawalRequest,
    } & CommonRequestOptions): Promise < ResponseWithBody < 200, void > | ResponseWithBody < 400, ApiError > | ResponseWithBody < 403, void > | ResponseWithBody < 404, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/withdrawals';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            if (parameters['withdrawal'] !== undefined) {
                body = parameters['withdrawal'];
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            form = queryParameters;
            queryParameters = {};

            this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    /**
     * Returns current user's broker logo.
     * @method
     * @name Api#getLogo
     */
    getLogo(parameters: CommonRequestOptions): Promise < ResponseWithBody < 200, GetLogoResponse > | ResponseWithBody < 400, ApiError > | ResponseWithBody < 403, void > | ResponseWithBody < 404, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/logo';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    getClientTradingInstruments(parameters: CommonRequestOptions): Promise < ResponseWithBody < 200, GetClientTradingInstrumentsResponse > | ResponseWithBody < 400, ApiError > | ResponseWithBody < 403, void > | ResponseWithBody < 404, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/client-trading-instruments';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    getMarketWidgets(parameters: CommonRequestOptions): Promise < ResponseWithBody < 200, GetMarketWidgetsResponse > | ResponseWithBody < 400, ApiError > | ResponseWithBody < 403, void > | ResponseWithBody < 404, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/market-widgets';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    putMarketWidgets(parameters: {
        'marketWidgets': number[],
    } & CommonRequestOptions): Promise < ResponseWithBody < 200, null > | ResponseWithBody < 400, ApiError > | ResponseWithBody < 403, void > | ResponseWithBody < 404, void > | ResponseWithBody < 500, void >> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/market-widgets';
        if (parameters.$path) {
            path = (typeof(parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any = parameters.marketWidgets;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('PUT', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }
}

export default Api;